var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInvestor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:#f6b756;}.cls-4{fill:url(#linear-gradient-3);}.cls-5{fill:#f2a961;}.cls-6{fill:url(#linear-gradient-4);}.cls-7{fill:url(#linear-gradient-5);}.cls-8{fill:#c7cdd8;}.cls-9{fill:url(#linear-gradient-6);}.cls-10{fill:#42455e;}.cls-11{fill:url(#linear-gradient-7);}.cls-12{fill:url(#linear-gradient-8);}.cls-13{fill:url(#linear-gradient-9);}.cls-14{fill:url(#linear-gradient-10);}.cls-15{fill:#fff2e3;}.cls-16{fill:#8288a1;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 32,
    y1: 41,
    x2: 32,
    y2: 1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#474f72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#878c9f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 32,
    y1: 37,
    x2: 32,
    y2: 9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbcc88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffe5c3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 32,
    y1: 33,
    x2: 32,
    y2: 13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e9a254"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f4bb79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    y1: 63,
    y2: 41,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 32,
    y1: 63,
    x2: 32,
    y2: 41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d4d8e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f3f4f5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    y1: 48.92,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 19,
    y1: 52,
    x2: 28.79,
    y2: 52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a0a6ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c6ccda"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 35.21,
    x2: 45,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 32,
    y1: 50.99,
    x2: 32,
    y2: 45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#da5466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f4929c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    y1: 63,
    y2: 51.01,
    xlinkHref: "#linear-gradient-9"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Investor") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Investor"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27,41v-.72A18,18,0,0,1,19.54,36l-4.09,2.36-5-8.66,4.09-2.36a17.47,17.47,0,0,1,0-8.62l-4.09-2.36,5-8.66L19.54,10A18,18,0,0,1,27,5.72V1H37V5.72A18,18,0,0,1,44.46,10l4.09-2.36,5,8.66-4.09,2.36a17.47,17.47,0,0,1,0,8.62l4.09,2.36-5,8.66L44.46,36A18,18,0,0,1,37,40.28V41Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 32,
    cy: 23,
    r: 14
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M32,37A14,14,0,0,1,18,22,14,14,0,0,0,46,22,14,14,0,0,1,32,37Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 32,
    cy: 23,
    r: 10
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M42,24a10,10,0,0,0-19.9,0A10,10,0,1,1,42,24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M57,63H7c.63-2.79.12-.55,2.88-12.66A12,12,0,0,1,21.58,41H42.42a12,12,0,0,1,11.7,9.34C56.92,62.64,56.41,60.36,57,63Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 24,
    y: 41,
    width: 16,
    height: 22
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M40,41c0,10.9.13,8.8-.38,11.12L32,47.36l-7.62,4.76C23.87,49.8,24,51.91,24,41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M40,41l-1.73,7.92L32,45l-6.27,3.92L24,41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M49.52,27.34c-6.5,15.51-28.53,15.53-35,0l-4,2.33,5,8.66L19.54,36A18,18,0,0,0,27,40.28V41l5,4,5-4v-.72A18,18,0,0,0,44.46,36l4.09,2.36,5-8.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M28.79,63H24.17L20,58l2-3-3-3,3-11h2C28.66,62.34,28.73,62.57,28.79,63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M42,55l2,3c-3,3.62-2.06,2.47-4.17,5H35.21c.06-.37-.33,1.43,4.79-22h2l3,11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M34.72,46.7,34.33,49a2.36,2.36,0,0,1-4.66,0l-.39-2.33L32,45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M35.16,63H28.84l.95-10a2.22,2.22,0,0,1,4.42,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M33,22H31a1,1,0,0,1,0-2h4a1,1,0,0,0,0-2H33V17a1,1,0,0,0-2,0v1a3,3,0,0,0,0,6h2a1,1,0,0,1,0,2H29a1,1,0,0,0,0,2h2v1a1,1,0,0,0,2,0V28a3,3,0,0,0,0-6Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "24.17 63 7 63 7.45 61 22.5 61 24.17 63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "57 63 39.83 63 41.5 61 56.55 61 57 63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M28.76,62.8c0,.28.69.2-4.59.2L22.5,61h5.87A12.15,12.15,0,0,1,28.76,62.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M41.5,61l-1.67,2H35.21c0-.32,0,.11.42-2Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvestor);
export default __webpack_public_path__ + "static/media/Investor.971a84caad5f951aa0746e8b211f4729.svg";
export { ForwardRef as ReactComponent };